var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcknowledgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4357_37366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4287 0C8.8167 0 0.928711 7.66262 0.928711 17C0.928711 26.3374 8.8167 34 18.4287 34C28.0407 34 35.9287 26.3374 35.9287 17C35.9287 7.66262 28.0407 0 18.4287 0ZM18.4287 30.0156C11.0787 30.0156 5.09863 24.14 5.09863 17C5.09863 9.86 11.0787 3.98438 18.4287 3.98438C25.7787 3.98438 31.7588 9.86 31.7588 17C31.7588 24.14 25.7787 30.0156 18.4287 30.0156Z",
    fill: "#781D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4287 5.97656C12.2093 5.97656 7.14941 10.9583 7.14941 17C7.14941 23.0417 12.2093 28.0234 18.4287 28.0234C24.6481 28.0234 29.708 23.0417 29.708 17C29.708 10.9583 24.6481 5.97656 18.4287 5.97656ZM25.3061 14.716L17.1029 22.6847C16.9027 22.8793 16.6403 22.9766 16.378 22.9766C16.1157 22.9766 15.8533 22.8793 15.653 22.6847L11.5515 18.7003C11.1508 18.3113 11.1508 17.6809 11.5514 17.2919C11.9519 16.9028 12.6009 16.9028 13.0014 17.2919L16.3779 20.5719L23.8561 13.3074C24.2566 12.9183 24.9056 12.9183 25.3061 13.3074C25.7066 13.6965 25.7066 14.3269 25.3061 14.716Z",
    fill: "#781D7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4357_37366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    fill: "white",
    transform: "translate(0.928711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcknowledgeIcon);
export default __webpack_public_path__ + "static/media/AcknowledgeIcon.f6b94258c4cd6120de1c2582fe9d30c9.svg";
export { ForwardRef as ReactComponent };